import {Spin} from "antd";

export default function Loading(){
    return <div className='h-[500px] c-flex'>
        <Spin />
    </div>
}